export default __webpack_public_path__ + "static/char-s-61-kr-d36dc6e2791127dcde3d3b7f609cce89.webp";